import React from 'react';
import { formatDateTimeForUser } from 'utils/dateTime';
import { CardDataBox } from './CardStyles';
import CardTypography from './CardTypography';

interface Props {
  uploadedAt?: string;
  isLoading: boolean;
  isUnavailable: boolean;
}

const StudyLastUpload = ({ uploadedAt, isLoading, isUnavailable }: Props) => {
  const value = isLoading
    ? 'Loading...'
    : isUnavailable
    ? 'Unavailable'
    : uploadedAt
    ? formatDateTimeForUser(uploadedAt)
    : 'Never';

  return (
    <CardDataBox>
      <CardTypography>Last upload</CardTypography>
      <CardTypography color="text.primary" bold>
        {value}
      </CardTypography>
    </CardDataBox>
  );
};

export default StudyLastUpload;
